var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15122_62360)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0876 5.41021C18.9082 5.49218 20.033 5.74753 20.8284 6.54302C22 7.7146 22 9.60021 22 13.3715C22 17.1427 22 19.0284 20.8284 20.1999C19.6569 21.3715 17.7712 21.3715 14 21.3715H10C6.22876 21.3715 4.34315 21.3715 3.17157 20.1999C2 19.0284 2 17.1427 2 13.3715C2 9.60021 2 7.7146 3.17157 6.54302C4.09333 5.62128 5.45706 5.42472 7.83335 5.38281",
    stroke: "#B28858",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 11.3711H6.19722C6.91179 11.3711 7.26908 11.3711 7.58952 11.4831C7.7852 11.5515 7.96906 11.6499 8.13451 11.7748C8.40544 11.9793 8.60363 12.2765 9 12.8711C9.39637 13.4657 9.59456 13.7629 9.86549 13.9674C10.0309 14.0923 10.2148 14.1907 10.4105 14.2591C10.7309 14.3711 11.0882 14.3711 11.8028 14.3711H12.1972C12.9118 14.3711 13.2691 14.3711 13.5895 14.2591C13.7852 14.1907 13.9691 14.0923 14.1345 13.9674C14.4054 13.7629 14.6036 13.4657 15 12.8711C15.3964 12.2765 15.5946 11.9793 15.8655 11.7748C16.0309 11.6499 16.2148 11.5515 16.4105 11.4831C16.7309 11.3711 17.0882 11.3711 17.8028 11.3711H22",
    stroke: "#B28858",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 14.0343C13.7185 13.9006 13.4577 13.7304 13.2236 13.5298C12.4746 12.8879 12 11.9349 12 10.8711C12 8.9381 13.567 7.37109 15.5 7.37109C17.433 7.37109 19 8.9381 19 10.8711C19 11.0409 18.9879 11.2078 18.9646 11.3711",
    stroke: "#B28858",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9002 10.2144C11.3406 9.59399 11 8.77232 11 7.87109C11 5.9381 12.567 4.37109 14.5 4.37109C16.433 4.37109 18 5.9381 18 7.87109C18 8.04085 17.9879 8.20779 17.9646 8.37109",
    stroke: "#B28858",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1318 9.35196C10.407 9.27619 9.74808 8.97923 9.22365 8.52979C8.47461 7.88787 8 6.93491 8 5.87109C8 3.9381 9.567 2.37109 11.5 2.37109C12.8361 2.37109 13.9973 3.11973 14.5871 4.22041",
    stroke: "#B28858",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15122_62360"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWallet);
export default __webpack_public_path__ + "static/media/iconWallet.f66eb0f69f777a712b37fb42f5e5ebe3.svg";
export { ForwardRef as ReactComponent };